import localStorage from 'platform/utilities/storage/localStorage';

/**
 * The two ways the combined history lists its rows. The table is the default.
 *
 * @type {Readonly<{ TABLE: 'table', CARD: 'card' }>}
 */
export const HISTORY_VIEWS = Object.freeze({
  TABLE: 'table',
  CARD: 'card',
});

/**
 * The localStorage key for the view choice, which both history pages share.
 *
 * @type {string}
 */
export const HISTORY_VIEW_STORAGE_KEY = 'arpSubmissionHistoryView';

/**
 * @param {unknown} view A saved value, or one the view switch reported.
 * @returns {string} `view` when it is one of `HISTORY_VIEWS`, else the table.
 */
export const toHistoryView = view =>
  Object.values(HISTORY_VIEWS).includes(view) ? view : HISTORY_VIEWS.TABLE;

/**
 * When localStorage is blocked at load, the platform's wrapper falls back to
 * sessionStorage, then a cookie, then memory, so the choice can still outlive
 * a reload. A read or write can still throw later, for example over quota or
 * after site data is cleared. A failed read falls back to the table.
 *
 * @returns {string} The saved view, one of `HISTORY_VIEWS`, or the table.
 */
export const readHistoryView = () => {
  try {
    return toHistoryView(localStorage.getItem(HISTORY_VIEW_STORAGE_KEY));
  } catch (e) {
    return HISTORY_VIEWS.TABLE;
  }
};

/**
 * @param {string} view One of `HISTORY_VIEWS`. A write that throws, as in
 *   `readHistoryView`, loses only the saved choice.
 */
export const saveHistoryView = view => {
  try {
    localStorage.setItem(HISTORY_VIEW_STORAGE_KEY, view);
  } catch (e) {
    /* see readHistoryView */
  }
};
